import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import AddCircle from '@mui/icons-material/AddCircle';
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import CircularProgress from '@mui/material/CircularProgress';

import { objectToQueryString, baseUrl, apiHelper } from 'helpers/util';

import ColumnBox from 'components/ColumnBox';
import SmallHeading from 'components/SmallHeading';

export default function Form(props) {
    const [ eventDate, setEventDate ] = useState(null);

    const [ contentType, setContentType ] = useState(null);
    const [ contentTitle, setContentTitle ] = useState('');
    const [ description, setDescription ] = useState('');
    const [ joinLink, setJoinLink ] = useState('');
    const [ selectedFileName, setSelectedFileName ] = useState(null);
    const [ imageBase64, setImageBase64 ] = useState(null);
    const [ isFormSubmitting, setIsFormSubmitting ] = useState(false);

    const contentTypeOptions = ["sunday_class"];
    const onClickSave = function() {
        const payload = { 'event_date': eventDate && eventDate.toISO ?
                eventDate.toISO() : eventDate,
            "title": contentTitle, 'type': contentType,
            "join_link": joinLink, "description": description,
            "image_base64": imageBase64, "image_filename": selectedFileName
        }
        setIsFormSubmitting(true);
        let apiUrl = `${baseUrl}/.netlify/functions/event_create`;
        let apiPromise = null;        
        apiPromise = apiHelper.post({ "url": apiUrl, "data": payload })

        apiPromise
        .then(response => {
            if (response.status) {
                console.log("Event created successfully");
                resetData();
            } else { console.log(response.json); }
            setIsFormSubmitting(false);
        })
    }

    const onFileSelected = function(files) {
        if (files && files.length > 0) {
            setSelectedFileName(files[0].name);
            var reader = new FileReader();
            reader.readAsDataURL(files[0]);
            reader.onload = function () {
                setImageBase64(reader.result.split(',')[1]);
            };
            reader.onerror = function (error) {
                console.log('Error: ', error);
            };
        }
    }

    const resetData = function() {
        setEventDate(null);
        setContentType(null);
        setContentTitle('');
        setDescription('');
        setJoinLink('');
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center',
            padding: '15px' }}>
            <ColumnBox sx={{ alignItems: 'center', maxWidth: '500px',
                width: '100%' }}>
                <SmallHeading>Event Details</SmallHeading>
                
                <Autocomplete
                    disablePortal
                    size="small"
                    onChange={(e, newValue) => { setContentType(newValue); }}
                    options={contentTypeOptions}
                    value={contentType}
                    sx={{ width: '100%', marginTop: '15px' }}
                    renderInput={(params) => <TextField {...params} label="Content Type" />}
                />
                <TextField label="Content Title" size="small"
                    sx={{ width: '100%', marginTop: '15px' }}
                    onChange={(e) => { setContentTitle(e.target.value); }}
                    value={contentTitle} />
                <TextField label="Description"
                    sx={{ width: '100%', marginTop: '15px' }}
                    minRows={2}
                    onChange={(e) => { setDescription(e.target.value); }}
                    value={description}
                    multiline={true} />
                <TextField label="Join Link" size="small"
                    sx={{ width: '100%', marginTop: '15px' }}
                    onChange={(e) => { setJoinLink(e.target.value); }}
                    value={joinLink} />
                <span style={{ color: 'grey', alignSelf: 'flex-start', fontStyle: 'italic' }}>{'Enter NA if session is in Temple'}</span>
                <Box sx={{ marginTop: '15px', width: '100%' }}>
                    <LocalizationProvider dateAdapter={AdapterLuxon}>
                        <MobileDateTimePicker
                            onChange={(newValue) => { setEventDate(newValue); }}
                            value={eventDate}
                            inputFormat="dd-MMM-yyyy hh:mm a"
                            mask=""
                            closeOnSelect={true}
                            disableMaskedInput={true}
                            renderInput={(params) => <TextField {...params}
                            label="Event Date" size="small" sx={{ width: '100%' }} />}
                            />
                    </LocalizationProvider>
                    <span style={{ color: 'grey', fontStyle: 'italic' }}>{'Users will be allowed to join 15 mins before this time'}</span>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', marginTop: '10px' }}>
                    <Button sx={{ margin: '0 5px 0 0' }}
                        variant="outlined"
                        component="label"
                        startIcon={ <UploadFileIcon /> }>Upload Image
                        <input type="file"
                            onChange={(e) => {
                                onFileSelected(e.target.files);
                            }} hidden />
                    </Button>
                    <Box><i>{selectedFileName || ''}</i></Box>
                </Box>

                { isFormSubmitting ? <CircularProgress sx={{ marginTop: '15px' }} /> :
                    <Button sx={{ marginTop: '15px' }} onClick={() => onClickSave()}
                        variant="outlined">Save</Button>
                }
            </ColumnBox>
        </Box>
    );
}
